import staffMemberFiltersSignal, {
	setStaffMemberFilters,
} from '@UI/Pages/Agencies/StaffMembers/Filters/Signals/staffMemberFiltersSignal';
import * as React from 'react';
import { useSignalValue } from '@verclam/pulsar';
import { Dropdown } from '@verclam/ui-kit';
import { fieldWithoutMarginStyles } from '@Guidelines/Theme/commonPassthrough';

type Props = {
	/** Job-function catalog; `null` while it is loading. */
	readonly options: ReadonlyArray<{ readonly value: string; readonly label: string }> | null;
	readonly withLabel?: boolean;
};

const JobFunctionFilter: React.FC<Props> = ({ options, withLabel = false }) => {
	const currentFilters = useSignalValue(staffMemberFiltersSignal);

	const handleJobFunctionChange = React.useCallback((jobFunction: string | null) => {
		setStaffMemberFilters(staffMemberFiltersSignal.peek().setJobFunction(jobFunction));
	}, []);

	return (
		<Dropdown<string>
			name="staffMemberJobFunction"
			label="Fonction"
			isLabelHidden={!withLabel}
			placeholder="Toutes les fonctions"
			options={options ? [...options] : []}
			optionLabel="label"
			optionValue="value"
			loading={options === null}
			showClear
			value={currentFilters.jobFunction}
			onChange={handleJobFunctionChange}
			pt={fieldWithoutMarginStyles}
		/>
	);
};

export default JobFunctionFilter;
